import { Injectable, inject } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from 'environments/environment';
import { SubscriptionModel } from 'app/shared/models/subscription.model';
import { ProductType } from 'app/models/account.model';

@Injectable({
    providedIn: 'root',
})
export class AccountService {
    private httpClient = inject(HttpClient);


    myClientAccounts = environment.ENDPOINTS.MY_CLIENT_ACCOUNTS_URL;
    subscription2Url = environment.ENDPOINTS.SUBSCRIPTIONS_URL;




    /**
     * Constructor
     *
     * @param httpClient http client
     */
    constructor() {
    }

    /**
     * get clients accounts
     */
    getAccountsClients(): Observable<any> {
        const req = this.myClientAccounts;
        return this.httpClient.get<any>(req);
    }

    /**
     * get clients accounts
     */
    getSubscriptionsByClientAccount({ clientAccountId }: { clientAccountId: number }): Observable<any> {
        const req = this.subscription2Url + `${clientAccountId}/subscriptions?applicationType=${ProductType.rhPartner}`;
        return this.httpClient.get<SubscriptionModel>(req);
    }

    getAccountClientById(id): Observable<any> {
        const req = this.myClientAccounts + `/${id}`;
        return this.httpClient.get<any>(req);
    }
}
